import { useRecuperarAutorizacionPorIdQuery } from '../../../../redux/api'
import { Toaster } from 'react-hot-toast'
import { Recordatorios } from '../../../recordatorios/Recordatorios'
import { useAutorizacionForm } from '../../models/autorizacionForm.type'
import { Recordatorio } from '../../../recordatorios/models'
import { useFieldArray } from 'react-hook-form'
import { Modal } from 'react-bootstrap'
import { useEffect } from 'react'
import { AppConstantes } from '../../../../utils/Constantes'

type Props = {
  idRelacionado: string | undefined
  titulo: string | undefined
  nombre: string | undefined
  show: boolean
  close: () => void
  refetch: () => void
  isModoEditar: boolean
  recordatorios?: Recordatorio[] | null | []
  esIndefinida: boolean | undefined
}

export const ModalAgregarEditarRecordatorio = ({
  idRelacionado,
  titulo,
  nombre,
  close,
  show,
  isModoEditar,
  esIndefinida,
}: Props) => {
  const formAutorizacion = useAutorizacionForm()

  const {
    control,
    reset,
    resetField,
    getValues,
    watch,
    formState: { errors },
    register,
    trigger,
  } = formAutorizacion

  const {
    data: autorizacion,
    isSuccess,
    refetch,
  } = useRecuperarAutorizacionPorIdQuery(idRelacionado ?? '', {})

  useEffect(() => {
    if (isModoEditar && isSuccess) {
      // Hidrata el form de autorización únicamente para reutilizar el componente `Recordatorios`.
      // Normaliza recordatorios a `{ unidad: {valor, etiqueta} }`.
      reset({
        ...autorizacion,
        autorizacion: {
          valor: autorizacion.autorizacion,
          etiqueta: autorizacion.descAutorizacion,
        },
        numero: autorizacion.numero,

        cantidadDuracion: autorizacion.cantidadDuracion,
        idSitio: { valor: autorizacion.idSitio, etiqueta: autorizacion.nombreSitio },
        idContactoSitio: {
          valor: autorizacion.idContactoSitio,
          etiqueta: autorizacion.nombreContactoSitio,
        },
        unidadDuracion: {
          valor: autorizacion.unidadDuracion,
          etiqueta: autorizacion.descUnidadDuracion,
        },
        estatus: {
          valor: autorizacion.estatus,
          etiqueta: autorizacion.descEstatus,
        },
        competencia: {
          valor: autorizacion.competencia,
          etiqueta: autorizacion.descCompetencia,
        },

        recordatorios: autorizacion.recordatorios?.map((r: Recordatorio) => {
          return {
            ...r,
            cantidad: r.cantidad,
            unidad: {
              valor: r.unidad,
              etiqueta: r.descUnidad,
            },
          }
        }),
      })
    }
  }, [isSuccess])

  const { remove } = useFieldArray({
    name: 'recordatorios',
    control,
  })

  /**
   * @description Cierra la ventana modal reseteando todos los campos
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 04/11/2022
   */
  const cerrarModalRecordatorios = () => {
    reset()
    remove()
    resetField('recordatorios')
    close()
    // Refresca la autorización para reflejar altas/bajas de recordatorios.
    refetch()
  }

  return (
    <div>
      <Toaster />
      <Modal
        show={show}
        size='lg'
        onHide={cerrarModalRecordatorios}
        dialogClassName='modal-dialog'
        keyboard={false}
        backdrop='static'>
        <Modal.Header>
          <div className='align-items-center d-flex flex-grow-1 '>
            {titulo ? <h4 className='modal-tittle'>{titulo}</h4> : ''}
            {nombre ? (
              <span className='text-muted fw-lighter fs-4 ps-2 d-flex'>| {nombre} </span>
            ) : (
              ''
            )}
          </div>
          <button
            className=' close btn  btn-outline-dark btn-icon btn-circle btn-sm ms-5 d-flex col-12 '
            onClick={cerrarModalRecordatorios}>
            <i className='fa-solid fa-plus fs-1' style={{ rotate: '45deg' }}></i>
          </button>
        </Modal.Header>

        <Modal.Body>
          <Recordatorios
            isModoEditar={true}
            esIndefinida={esIndefinida}
            // Para autorizaciones, la fecha de referencia para cálculo de recordatorios es vencimiento.
            fechaReferencia={autorizacion?.fechaVencimiento}
            idRelacionado={autorizacion?.idAutorizacion}
            tipo={AppConstantes.CVE_RECORDATORIO_AUTORIZACION}
            isModalRecordatorios={true}
            estatus={autorizacion?.estatus}
            {...{
              getValues,
              trigger,
              watch,
              control,
              register,
              errors,
            }}></Recordatorios>
        </Modal.Body>
        <Modal.Footer>
          <button type='reset' className=' btn  text-hover-dark btn-cancelar' onClick={cerrarModalRecordatorios}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
